import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDraggable = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 7,
	viewBox: "0 0 15 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .964294,
		y: .65332,
		width: 13.9751,
		height: 1.52455,
		rx: .762277,
		fill: "#616161"
	}), /* @__PURE__ */ _jsx("rect", {
		x: .964294,
		y: 5.22705,
		width: 13.9751,
		height: 1.52455,
		rx: .762277,
		fill: "#616161"
	})]
});
const ForwardRef = forwardRef(SvgDraggable);
export default ForwardRef;
